import { Box } from "@mui/material";
import { blue } from "@mui/material/colors";

export interface ICheckoutHeaderProps {
  height?: string | number;
}

/**
 * Placeholder visual que aparece durante o drag para indicar
 * onde o componente será inserido na lista.
 *
 * Design: barra horizontal azul animada com gradiente sutil,
 * em vez de um bloco cinza grande que ocupa espaço visual.
 */
const CheckoutEmpty = ({ height = 6 }: ICheckoutHeaderProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: height,
        borderRadius: "3px",
        background: `linear-gradient(90deg, ${blue[400]}, ${blue[600]}, ${blue[400]})`,
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s ease-in-out infinite",
        my: 0.5,
        "@keyframes shimmer": {
          "0%": { backgroundPosition: "200% 0" },
          "100%": { backgroundPosition: "-200% 0" },
        },
      }}
    />
  );
};

export default CheckoutEmpty;
